import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {  Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Aside from '../../components/Aside/Aside';
import Footer from '../../components/Footer/Footer';
import Home from '../Home';
import RecentlyAdded from '../Home/RecentlyAdded';
import SearchPage from '../Home/search';
import Directory from '../directory'
import Country from '../Home/country';
import Industry from '../Home/industry';
import IndustryCity from '../Home/industryCity';
// import Region from '../Home/region';
import State from '../Home/state';
import City from '../Home/city';
import Join from '../Join';
// import News from '../News';
// import Trending from '../News/trending';
import Exportlist from '../ExportList';
import About from '../About';
// import BlogDetail from '../BlogDetail';
// import Algo from '../Algo';
// import Press from '../Press';
import API from '../API';
import TopPages from '../TopPages';
import AddCompany from '../AddCompany';
import Welcome from '../Welcome';
// import FastestStartUp from '../Home/FastestStartUp';
import ScheduleDemo from '../ScheduleDemo/index';
import Terms from '../Terms';
import Privacy from '../Privacy';
import Co_Op from '../Co_Op/index';
import Media from '../Media';
import ContactUs from '../Contact';
import GrowjoRemoval from '../Contact/growjo_removal';
import CompanyDetail from '../CompanyDetail';
import EmployeeDetail from '../EmployeeDetail';
import './index.css';
import Postman from '../../utils/service';
import Modal from 'react-modal';
import SingupForm from '../../components/signup'
import { login } from "../../actions/AuthActions";
import AddNewCompany from '../AddNewCompany';
import EditCompany from '../EditCompany';
import EditFunding from '../EditCompany/Funding';
import EditEmployee from '../EditCompany/Employee';
import AboutOurData from '../AboutOurData/index';
import WhatIsZoomInfo from '../WhatIsZoomInfo/index';
import Logout from '../Logout';
import Cookies from 'js-cookie';
import TidioChat from '../../components/TidioChat/index';


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '837px',
    height: '450px',
    border: 0,
    padding: 33,
    borderRadius: 0
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.8)',
    zIndex: 10000
  }
};


const nameCapitalized = name => (name.charAt(0).toUpperCase() + name.slice(1))
const isFirstCapital = str => (str[0].toUpperCase() == str[0] ? true : false)
class Full extends Component {
  constructor() {
    super()
    this.state = {
      filterData: null,
      showLoginModal: false,
      errors: '',
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false
    }
    this.saveLandingPage();
  }

  saveLandingPage = () =>{
    if(!this.state.isLoggedIn){
      if(!Cookies.get('landingPage') && typeof window  != 'undefined'){
        Cookies.set('landingPage',  window.location.pathname)
      }
    }
  }

  openLoginModal = () => {
    this.setState({ showLoginModal: true });
  }
  closeLoginModal = () => {
    this.setState({ showLoginModal: false });
  }

  componentDidMount() {
    if (!this.state.filterData && (this.props.history.location.pathname == '/' || this.props.history.location.pathname.includes('/search')
    || this.props.history.location.pathname.includes('/employee-search'))) {
      Postman.getDataForFilter()
        .then(res => {
          this.setState({ filterData: res.data })
        })
    }

    window.scrollTo(0, 0);
    const { auth } = this.props

  }
  

  componentWillReceiveProps(nextProps) {
    window.scrollTo(0, 0);
    const { auth, errors } = nextProps
    const { showLoginModal } = this.state
    if (auth.isAuthenticated && this.props.history.location.pathname.indexOf("welcome") < 0 && showLoginModal == true) {
      this.setState({ showLoginModal: false }, () => {
        this.props.history.push("/welcome");
      });
    }

    if (!auth.isAuthenticated && errors) {
      this.setState({
        errors,
      });
    }

    if ( (this.props.history.location.pathname == '/' ||  this.props.history.location.pathname == '/search')
    || this.props.history.location.pathname == '/employee-search') {
      Postman.getDataForFilter()
        .then(res => {
          this.setState({ filterData: res.data })
        })
    }
  }

  render() {
    return (
      <div className="app">
        <Header />
        <div className={"appbody " }>
          <Sidebar {...this.props} />
          <main className="main">
            <Container fluid>
              <Switch>
                <Route path="/" name="home" component={Home} exact={true} />
                <Route path="/home/:page" name="Home" component={Home} exact={true} />

                <Route path="/search" name="searchPage" component={SearchPage} exact={true} />
                <Route path="/search/:page" name="searchPage" component={SearchPage} exact={true} />

                <Route path="/employee-search" name="empSearchPage" component={SearchPage} exact={true} />
                <Route path="/employee-search/:page" name="empSearchPage" component={SearchPage} exact={true} />

                <Route path="/directory/:char-:page" name="Directory" component={Directory} exact={true} />
                <Route path="/directory/:char" name="Directory" component={Directory} exact={true} />
                <Route path="/directory" name="Directory" component={Directory} exact={true} />

                <Route path="/top_competitors" name="toppages" component={TopPages} exact />
                <Route path="/what-is-zoominfo" name="toppages" component={WhatIsZoomInfo} exact />
                <Route path="/recently_added" name="toppages" component={RecentlyAdded} exact />

                <Route path="/add_company/:token" name="addcompany" component={AddCompany} />
                <Route path="/aboutus" name="About" component={About} />
                <Route path="/about_our_data" name="AboutOurData" component={AboutOurData} />
                {/* <Route path="/algo" name="Algo" component={Algo} /> */}
                <Route path="/company/:name" name="HomeDetail" component={CompanyDetail} />
                {<Route path="/employee/:name" name="EmpDetail" component={EmployeeDetail} /> }
                <Route path="/state/:state" name="HomeState" component={State} exact />
                <Route path="/state/:state/:page" name="HomeState" component={State} exact />
                <Route path="/country/:country" name="HomeCountry" component={Country} exact />
                <Route path="/country/:country/:page" name="HomeCountry" component={Country} exact />
                <Route path="/industry/:industry" name="HomeIndustry" component={Industry} exact />
                <Route path="/industry/:industry/:page" name="HomeIndustry" component={Industry} exact />

                <Route path="/list/:industry/:city" name="HomeIndustryCity" component={IndustryCity} exact />
                <Route path="/list/:industry/:city/:page" name="HomeIndustryCity" component={IndustryCity} exact />

                {/* <Route path="/msps/:region" name="HomeRegion" component={Region} exact /> */}
                {/* <Route path="/msps/:region/:page" name="HomeRegion" component={Region} exact /> */}
                <Route path="/city/:city" name="HomeCity" exact
                  render={(props) => {
                    const { city } = props.match.params
                    return (isFirstCapital(city) ? <City {...props} /> : <Redirect to={`/city/${nameCapitalized(city)}`} />)
                  }}
                />
                <Route path="/city/:city/:page" name="HomeCity" exact
                  render={(props) => {
                    const { city, page } = props.match.params
                    return (isFirstCapital(city) ? <City {...props} /> : <Redirect to={`/city/${nameCapitalized(city)}/${page}`} />)
                  }}
                />
                {/* <Route path="/press/:name" name="Press" component={Press} /> */}
                {/* <Route path="/news" name="News" component={News} exact /> */}
                {/* <Route path="/trending" name="Trending" component={Trending} exact /> */}
                <Route path="/company_api" name="API" component={ScheduleDemo} exact />
                {/* <Route path="/company_api" name="API" component={API} exact /> */}
                <Route path="/company_data_api" name="API" component={API} exact />
                <Route path="/terms" name="API" component={Terms} exact />
                <Route path="/privacy" name="API" component={Privacy} exact />
                <Route path="/contact" name="API" component={ContactUs} exact />
                <Route path="/do_not" name="API" component={GrowjoRemoval} exact />
                <Route path="/co-op" name="CoOp" component={Co_Op} />

                {/* <Route path="/news/:title" name="BlogDetail" component={BlogDetail} /> */}
                {/* <Route path="/fastest-startups-per-capita" name="FastestStartUp" component={FastestStartUp} /> */}
                <Route path="/schedule-demo" name="ScheduleDemo" component={ScheduleDemo} />
                {/* <Route path="/best-marketing-podcasts-episodes" name="BestEpisodes" component={BestEpisodes} /> */}
                {/* <Route path="/reports_awards" name="ReportAwards" component={ReportAwards} exact /> */}
                <Route path="/media" name="Media" component={Media} exact />


                {/* {this.state.isLoggedIn && <Route path="/export_list" name="Exportlist" component={Welcome} />} */}

                {this.state.isLoggedIn && <Route path="/export_list" name="Exportlist"
                  render={(props) => {
                    return (<Welcome {...this.props} />)
                  }}

                />}
                {this.state.isLoggedIn && <Route path="/welcome" name="welcome"
                  render={(props) => {
                    return (<Welcome {...this.props} />)
                  }}

                />}

                {/* {this.state.isLoggedIn && <Route path="/welcome" name="welcome" component={Welcome} />} */}
                {this.state.isLoggedIn && <Route path="/edit_company/:name" name="editcompany" component={EditCompany} exact={true} />}
                {this.state.isLoggedIn && <Route path="/edit_company/:name/:type" name="editcompany" component={EditCompany} exact={true} />}
                {this.state.isLoggedIn && <Route path="/edit_funding/:id" name="editfunding" component={EditFunding} />}
                {this.state.isLoggedIn && <Route path="/edit_employee/:id" name="editemployee" component={EditEmployee} />}
                {this.state.isLoggedIn && <Route name="registerCompany" path='/register-company'
                  component={() => <EditCompany addNewCompany={true} />} />}
                  {<Route name="addYourCompany" path='/add-your-company'
                  component={() => <AddNewCompany addNewCompany={true} />} />}

                {!this.state.isLoggedIn && <Route path="/export_list" name="Exportlist" component={Exportlist} />}
                {!this.state.isLoggedIn && <Route path="/join" name="Join" component={Join} />}

                <Route path="/logout" name="logout" component={Logout} />
                <Redirect to="/" />

              </Switch>
            </Container>
            {
            (this.props.history.location.pathname.includes('/search') || this.props.history.location.pathname.includes('/employee-search')  ) && this.state.isLoggedIn &&
            <Aside filterData={this.state.filterData} />
          }
          </main>
        
        </div>
        <Footer />
        { !this.props.history.location.pathname.includes('/search') && !this.props.history.location.pathname.includes('/employee-search') &&
            <TidioChat />}
        <Modal
          isOpen={this.state.showLoginModal && (this.props.history.location.pathname.indexOf('join') < 0)}
          onRequestClose={this.closeLoginModal}
          style={customStyles}
          contentLabel="Example Modal"
          shouldFocusAfterRender={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={true}
        >
          <i className='icon-close' onClick={this.closeLoginModal} />
          <h4 style={{ color: 'rgb(41, 101, 138)', fontSize: 18 }}>Export the Growjo 10000</h4>
          <p style={{ color: 'grey', fontSize: 14, marginBottom: 12, float: 'left' }}>Join and get the list of the fastest growing companies free</p>
          <SingupForm modal />
          <div className="exportlistImg-wrapper">
            <img src="/static/exportlist/subscribe.png" width="100%" />
          </div>
        </Modal>
      </div>
    );
  }
}
Full.propTypes = {
  login: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { login }
)(Full);




// WEBPACK FOOTER //
// ./client/src/views/Full/index.js